var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tile",on:{"click":function($event){return _vm.$emit('tileClick')}}},[_c('div',{staticClass:"tile-header"},[_c('svg',{attrs:{"width":"24","height":"24","viewBox":"0 0 24 24"},domProps:{"innerHTML":_vm._s(_vm.icon)}}),_c('span',[_vm._v(_vm._s(_vm.header))])]),_c('div',{staticClass:"tile-content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }